import actionTypes from '../constants/action-types';
import constants from '../constants';

const siteCustomization = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_SITE_CUSTOMIZATION: {
      return action.payload.siteCustomizationConfig;
    }

    case actionTypes.ADD_CUSTOM_TEXT_COLOR: {
      const { customTextColors = [] } = state;

      if (customTextColors.length < constants.MAX_COLOR_TEXT_OPTIONS) {
        return {
          ...state,
          customTextColors: [...customTextColors, action.payload.color],
        };
      }

      return {
        ...state,
        customTextColors: [...customTextColors.slice(1), action.payload.color],
      };
    }

    case actionTypes.ADD_CUSTOM_COLOR_PALETTE: {
      return {
        ...state,
        customColorPalettes: [...state.customColorPalettes, action.payload.palette],
      };
    }

    case actionTypes.DELETE_CUSTOM_COLOR_PALETTE: {
      const newState = state.customColorPalettes.filter(({ id }) => id !== action.payload.id);

      return {
        ...state,
        customColorPalettes: [...newState],
      };
    }

    case actionTypes.UPDATE_CUSTOM_COLOR_PALETTE: {
      const filteredState = state.customColorPalettes.filter(
        ({ id }) => id !== action.payload.palette.id
      );
      return {
        ...state,
        customColorPalettes: [...filteredState, action.payload.palette],
      };
    }

    case actionTypes.ADD_CUSTOM_FONT_PAIR: {
      const { customFontPairs = [] } = state;

      return {
        ...state,
        customFontPairs: [...customFontPairs, action.payload.fontPair],
      };
    }

    case actionTypes.DELETE_CUSTOM_FONT_PAIR: {
      const newState = state.customFontPairs.filter(({ id }) => id !== action.payload.id);

      return {
        ...state,
        customFontPairs: [...newState],
      };
    }

    case actionTypes.UPDATE_CUSTOM_FONT_PAIR: {
      const filteredState = state.customFontPairs.filter(
        ({ id }) => id !== action.payload.fontPair.id
      );
      return {
        ...state,
        customFontPairs: [...filteredState, action.payload.fontPair],
      };
    }

    case actionTypes.SET_CURRENT_COLOR_PALETTE_VERSION: {
      return {
        ...state,
        currentColorPaletteVersion: action.payload.version,
      };
    }

    case actionTypes.SET_CURRENT_BUTTON_PRESET_VERSION: {
      return {
        ...state,
        currentButtonPresetVersion: action.payload.version,
      };
    }

    case actionTypes.ADD_CUSTOM_COLOR: {
      const { customColors = [] } = state;
      const filteredCustomColors = customColors.filter(
        (color) =>
          color.value !== action.payload.color.value ||
          color.opacity !== action.payload.color.opacity
      );

      if (filteredCustomColors.length < constants.MAX_CUSTOM_COLORS_AMOUNT) {
        return {
          ...state,
          customColors: [action.payload.color, ...filteredCustomColors],
        };
      }

      return {
        ...state,
        customColors: [
          action.payload.color,
          ...filteredCustomColors.slice(0, filteredCustomColors.length - 1),
        ],
      };
    }

    case actionTypes.ADD_CUSTOM_GRADIENT: {
      const { customGradients = [] } = state;
      const filteredCustomGradients = customGradients.filter(
        (gradient) => gradient.value !== action.payload.gradient.value
      );

      if (filteredCustomGradients.length < constants.MAX_CUSTOM_GRADIENTS_AMOUNT) {
        return {
          ...state,
          customGradients: [action.payload.gradient, ...filteredCustomGradients],
        };
      }

      return {
        ...state,
        customGradients: [
          action.payload.gradient,
          ...filteredCustomGradients.slice(0, filteredCustomGradients.length - 1),
        ],
      };
    }

    default:
      return state;
  }
};

export default siteCustomization;
